import React, { useState } from "react";
import CustomRadio from "Common/CustomRadio";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import ReactPortal from "Components/ReactPortal/ReactPortal";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import Validator, {
    ValidationTypes as V_Type,
} from "react-form-supervalidator";
import api from "http";
import { toast } from "react-toastify";
import PropTypes from 'prop-types';
import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew";
import MultiEmailInput from "Common/MultiEmailInput/MultiEmailInput";
import CustomDraggable from "Common/CustomDraggable/CustomDraggable";
import CustomInput from "Common/CustomInput/CustomInput";
import MaskPhoneNumber from "Utils/MaskPhoneNumber";
import { phoneLengthValidator } from "Utils/validators";

const PaymentRequestResendPopup = ({ onClose, paymentMainId, disableDraggable, row }) => {
    const uniqueId = "PaymentReceiptPopup"
    let number
    let Emails
    if (row.sentVia.includes(",")){
        const parts = row.sentTo.split(",");
         number = parts.find(part => /^\d+$/.test(part));
         Emails = parts.filter(part => !/^\d+$/.test(part)).join(",");
    }
    const [emails, setEmails] = useState(row.sentVia.includes(",") ? [Emails] : row.sentVia === "Email" ? [row.sentTo] : []);
    const [paymentReceipt, setPaymentReceipt] = useState({
        receiptModel: {
            paymentMainId,
            emailTo: row.sentVia === "Email" ? [row.sentTo] : [],
            phoneNumber: row.sentVia.includes(",") ? number : row.sentVia === "Text" ? row.sentTo:   '',
            transferVia: row.sentVia.includes(",") ? "Email": row.sentVia,
        },
        loader: false,
        isEmail: true,
    });
    
    const [myValidationModel, setMyValidationModel] = useState({
        errorEmailTo: null,
        errorPhoneNumber: null,
    });
    const setValidation = () => {
        let myvalidation_Obj = {
            ...myValidationModel,
            ...(paymentReceipt.receiptModel.transferVia === "Email" && {
                errorEmailTo: Validator(
                    emails,
                    [V_Type.required],
                    ["Email is required"]
                ),
            }),
            ...(paymentReceipt.receiptModel.transferVia !== "Email" && {
                errorPhoneNumber: Validator(
                    paymentReceipt.receiptModel.phoneNumber,
                    [V_Type.required, phoneLengthValidator],
                    ["Phone is required", "Phone number is not valid"]
                ),
            }),
        };
        setMyValidationModel(myvalidation_Obj);
        return Validator(myvalidation_Obj, V_Type.NullCheck);
    };


    const handleSendReceipt = async() => {
        let my_validation = setValidation();
        if (!my_validation) {
            let sentTo = "";
            if (paymentReceipt.receiptModel.transferVia === 'Email') {
                sentTo = (emails && emails.length) ? emails.join(',') : "";
            } else if (paymentReceipt.receiptModel.transferVia === 'Text' && paymentReceipt.receiptModel.phoneNumber) {
                sentTo = paymentReceipt.receiptModel.phoneNumber;
            }
            try {
                setPaymentReceipt((prev) => ({ ...prev, loader: true }));
                const payload = {
                    id: row.id,
                    sentTo,
                    sentVia: paymentReceipt.receiptModel.transferVia,
                }
                const resp = await api.post(`${process.env.REACT_APP_TC_PMS}/api/PatientPayment/ReSendPaymentRequest`, payload)
                toast.success(resp.data.dataModel.responseMessage);
                onClose();
            } catch (error) {
                ErrorHandlingMessage(error);
            }finally{
                setPaymentReceipt((prev) => ({ ...prev, loader: false }));
            }
        
        }
    };


    const handleChange = (e) => {
        let { name, value } = e.target;
        if (name === "transferVia") {
            setPaymentReceipt((prev) => ({
                ...prev,
                receiptModel: {
                    ...prev.receiptModel,
                    transferVia: value,
                },
            }));
            setMyValidationModel((prev) => ({
                errorPhoneNumber: null,
                errorEmailTo: null,
            }));
        } else if (name === "phoneNumber") {
            value = value = MaskPhoneNumber(value, "removeMask");
            setPaymentReceipt((prev) => ({
                ...prev,
                receiptModel: { ...paymentReceipt.receiptModel, [name]: value },
            }));
        }
        else {
            setPaymentReceipt((prev) => ({
                ...prev,
                receiptModel: { ...paymentReceipt.receiptModel, [name]: value },
            }));
        }
    };
    return (
        <ReactPortal wrapperId={uniqueId}>
            {paymentReceipt.loader && <FullPageLoader allowFullScreen={true} />}
            <div
                data-te-modal-init
                className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-[400px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        <div
                            id={uniqueId}
                            className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
                        >
                            Resend Payment Request
                        </div>
                        <div className="px-5 pt-5 overflow-y-auto max-h-[70vh]">
                            <div className="flex flex-col">
                                <div className="flex gap-4">
                                    <CustomRadio
                                        name="transferVia"
                                        checked={paymentReceipt.receiptModel.transferVia}
                                        options={[
                                            { value: "Email", label: "Email" },
                                            { value: "Text", label: "Phone Number" }
                                        ]}
                                        onChange={handleChange}
                                    />

                                </div>
                                {paymentReceipt.receiptModel.transferVia === "Email" ? (
                                    <div className="flex flex-col w-full mt-3">
                                        <MultiEmailInput
                                            emails={emails}
                                            setEmails={setEmails}
                                            setMyValidationModel={setMyValidationModel}
                                        />
                                        <span className='text-sm text-primary'>{myValidationModel.errorEmailTo}</span>
                                        <span className="text-sm">
                                            Separate multiple email addresses with Enter, Comma, or Space.
                                        </span>
                                    </div>
                                ) : (
                                    <div className="flex flex-col w-full mt-3">

                                        <CustomInput
                                            onChange={handleChange}
                                            name="phoneNumber"
                                            value={MaskPhoneNumber(paymentReceipt.receiptModel.phoneNumber, "generatemask")}
                                            label="Phone Number"
                                            placeholder="(123) 456-7896"
                                        />
                                        {myValidationModel.errorPhoneNumber}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
                            <CustomButtonNew label="Cancel" variant="outline" onClick={onClose} />
                            <CustomButtonNew label="Send" onClick={handleSendReceipt} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    );
};

export default PaymentRequestResendPopup;
PaymentRequestResendPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    paymentMainId: PropTypes.string,
};